// import moment from 'moment'
import _ from 'lodash'

import api from '@/utils/api'
import axios from 'axios'
import STATUS from '@/utils/status'

import eventsBus from '@/components/shared/EventsBus'

const state = {
  eventsList: {
    data: [],
    status: STATUS.LOADING,
    nextUrl: null,
    previousUrl: '/prevEvents'
  },
  cancelSources: {
    load: null
  }
}

const mutations = {
  clearEventsList (state) {
    state.eventsList.data = []
    state.eventsList.status = STATUS.LOADING
    state.eventsList.nextUrl = null
    state.eventsList.previousUrl = '/prevEvents'
  },
  setEventLists (state, data) {
    state.eventsList.data = data.data
    state.eventsList.status = STATUS.LOADED
    state.eventsList.nextUrl = data.nextUrl
  },
  appendEventLists (state, data) {
    state.eventsList.data = _.uniqBy(state.eventsList.data.concat(data.data), (e) => e.id)
    state.eventsList.status = STATUS.LOADED
    if (data.data.length === 0) {
      state.eventsList.nextUrl = null
    } else {
      state.eventsList.nextUrl = data.nextUrl
    }
  },
  prependEventLists (state, data) {
    state.eventsList.data = _.uniqBy(data.data.concat(state.eventsList.data), (e) => e.id)
    state.eventsList.status = STATUS.LOADED
    if (data.data.length === 0) {
      state.eventsList.previousUrl = null
    } else {
      state.eventsList.previousUrl = data.nextUrl
    }
  },
  addOrUpdateEvent (state, event) {
    let existingEvent = _.find(state.eventsList.data, (e) => e.id === event.id)
    if (!existingEvent) {
      state.eventsList.data.push(event)
    } else {
      let answers = existingEvent.answers
      for (let k in event) {
        existingEvent[k] = event[k]
      }
      existingEvent.answers = answers
    }
  },
  removeEventFromEventsList (state, event) {
    state.eventsList.data = state.eventsList.data.filter((e) => e.id !== event.id)
  }
}

const actions = {
  load (ctx, options) {
    return new Promise((resolve, reject) => {
      let cancelSources = ctx.state.cancelSources
      if (cancelSources.load) {
        cancelSources.load.cancel()
      }
      cancelSources.load = axios.CancelToken.source()
      let groopsParam = -1
      if (ctx.rootGetters['groops/groops'] !== options.groops) {
        groopsParam = options.groops.map((group) => group.id).join(',')
      }
      api.get('eventsBetween/' + options.start + '/' + options.end, {params: {group: groopsParam}, cancelToken: cancelSources.load.token}).then((response) => {
        resolve(response.data.events)
      }).catch(reject)
    })
  },
  getEvent (ctx, id) {
    return new Promise((resolve, reject) => {
      api.get(`/event/${id}`).then((response) => {
        resolve(response.data.event)
      }).catch(() => {
        reject()
      })
    })
  },

  putEvent (ctx, data) {
    return api.put('/event/' + data.id, data).then((response) => {
      eventsBus.$emit('updatedEvent', {event: data})
      ctx.dispatch('toAnswer/refresh', null, {root: true})
      return response
    })
  },

  putEventStatus (ctx, data) {
    return api.put('/event/' + data.id + '/status', {status: data.status}).then((response) => {
      eventsBus.$emit('updatedEvent', {event: data})
      return response
    })
  },

  putEventGeneralAnswer (ctx, data) {
    return api.put('/event/' + data.id + '/generalAnswer', {
      name: data.name,
      answer: data.answer
    }).then((response) => {
      eventsBus.$emit('updatedEvent', {event: data})
      return response
    })
  },
  putEventAnswerWithRegistrationKey (ctx, data) {
    return api.put('/event/' + data.eventId + '/answer/key', {
      userId: data.userId,
      answer: data.answer,
      registrationKey: data.registrationKey
    }, {__canHaveNoToken: true}).then((response) => {
      return response
    })
  },
  putEventAnswer (ctx, data) {
    let oldAnswer = null
    if (data.event.answers && data.event.answers[data.user.id]) {
      oldAnswer = data.event.answers[data.user.id].answer
      data.event.answers[data.user.id].answer = data.answer
    }
    return api.put('/event/' + data.event.id + '/answer', {
      userId: data.user.id,
      answer: data.answer
    }).then((response) => {
      eventsBus.$emit('updatedEvent', {event: data})
      ctx.dispatch('toAnswer/refresh', null, {root: true})
      return response
    }).catch(() => {
      if (data.event.answers && data.event.answers[data.user.id]) {
        data.event.answers[data.user.id].answer = oldAnswer
      }
    })
  },

  postEvent (ctx, data) {
    return api.post('/event', data).then((response) => {
      eventsBus.$emit('newEvent', {event: data})
      ctx.dispatch('toAnswer/refresh', null, {root: true})
      return response
    })
  },

  loadEventsList (ctx, options = {groops: []}) {
    ctx.commit('clearEventsList')
    return new Promise((resolve, reject) => {
      let cancelSources = ctx.state.cancelSources
      if (cancelSources.loadEventsList) {
        cancelSources.loadEventsList.cancel()
      }
      cancelSources.loadEventsList = axios.CancelToken.source()
      let groopsParam = -1
      if (ctx.rootGetters['groops/groops'] !== options.groops) {
        groopsParam = options.groops.map((group) => group.id).join(',')
      }
      api.get('nextEvents', {params: {group: groopsParam}, cancelToken: cancelSources.loadEventsList.token}).then((response) => {
        ctx.commit('setEventLists', {data: response.data.events, nextUrl: response.data.nextApiCall})
      }).catch(reject)
    })
  },
  loadMoreEventsList (ctx, options = {groops: []}) {
    let groopsParam = -1
    if (ctx.rootGetters['groops/groops'] !== options.groops) {
      groopsParam = options.groops.map((group) => group.id).join(',')
    }
    return new Promise((resolve, reject) => {
      api.get(ctx.state.eventsList.nextUrl, {params: {group: groopsParam}}).then((response) => {
        ctx.commit('appendEventLists', {data: response.data.events, nextUrl: response.data.nextApiCall})
        resolve()
      }).catch(reject)
    })
  },
  loadMorePreviousEventsList (ctx, options = {groops: []}) {
    let groopsParam = -1
    if (ctx.rootGetters['groops/groops'] !== options.groops) {
      groopsParam = options.groops.map((group) => group.id).join(',')
    }

    return new Promise((resolve, reject) => {
      api.get(ctx.state.eventsList.previousUrl, {params: {group: groopsParam}}).then((response) => {
        ctx.commit('prependEventLists', {data: response.data.events, nextUrl: response.data.nextApiCall})
        resolve()
      }).catch(reject)
    })
  },
  cleanEventsList (ctx) {
    return ctx.commit('clearEventsList')
  },
  removeEventFromEventsList (ctx, event) {
    ctx.commit('removeEventFromEventsList', event)
  },
  updateList (ctx, events) {
    events.forEach(function (event) {
      ctx.commit('addOrUpdateEvent', event)
    })
  },
  refreshEvent (ctx, event) {
    ctx.dispatch('getEvent', event.id).then((e) => {
      event.answers = e.answers
      event.groupAnswer = e.groupAnswer
      event.status = e.status
      event.blinded = e.blinded
      event.hasMaybe = e.hasMaybe
      event.name = e.name
      event.public = e.public
      event.startTime = e.startTime
      event.startTimeStr = e.startTimeStr
      event.endTime = e.endTime
      event.endTimeStr = e.endTimeStr
      event.permissions = e.permissions
      event.type = e.type
      event.url = e.url
      event.city = e.city
      event.description = e.description
      event.streetAndNum = e.streetAndNum
      event.deleted = e.deleted
    })
  },
  togglePublishEvent (ctx, event) {
    event.public = !event.public
    ctx.dispatch('putEvent', {id: event.id, publishOnGroupPage: event.public})
  },
  toggleBlindedEvent (ctx, event) {
    event.blinded = !event.blinded
    ctx.dispatch('putEvent', {id: event.id, blinded: event.blinded}).then((response) => {
      ctx.dispatch('getEvent', event.id).then((e) => {
        event.answers = e.answers
      })
    })
  },
  deleteEvent (ctx, event) {
    return api.delete('event/' + event.id).then((response) => {
      eventsBus.$emit('deletedEvent', {event: event})
      return response
    })
  }
}

const getters = {
  conversationsUpdateCount (state) {
    return state.conversationsUpdateCount
  },

  eventsList (state) {
    return state.eventsList.data
  },

  eventsListStatus (state) {
    return state.eventsList.status
  },

  eventsListByMonth (state) {
  },

  eventsListCanLoadPrevious (state) {
    return state.eventsList.previousUrl !== null
  },

  eventsListCanLoadMore (state) {
    return state.eventsList.nextUrl !== null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/events.js